const BASE_ID = process.env.REACT_APP_AIRTABLE_BASE_ID;
const API_TOKEN = process.env.REACT_APP_AIRTABLE_API_TOKEN;

const cache = {};

function fetchTable(table) {
  if (cache[table]) return cache[table];

  cache[table] = fetch(
    `https://api.airtable.com/v0/${BASE_ID}/${encodeURIComponent(table)}?view=Grid%20view`,
    { headers: { Authorization: `Bearer ${API_TOKEN}` } },
  )
    .then((res) => res.json())
    .then((data) => {
      const records = data.records || [];
      warmImages(records);
      return records;
    })
    .catch((err) => {
      console.error(`Error fetching ${table}:`, err);
      delete cache[table];
      return [];
    });

  return cache[table];
}

function warmImages(records) {
  records.slice(0, 10).forEach((record) => {
    const image = record.fields?.Attachments?.[0];
    const thumb = image?.thumbnails?.large ?? image;
    if (thumb?.url) {
      const img = new Image();
      img.src = thumb.url;
    }
  });
}

export function prefetchGalleries() {
  fetchTable('Paintings');
  fetchTable('Drawings');
  fetchTable('Works For Sale');
}

export function loadGallery(table) {
  return fetchTable(table);
}
